// extracted by mini-css-extract-plugin
module.exports = {"list":"List_list__3ccy6"};